import { render, staticRenderFns } from "./BookHourlyDepartmentCard.vue?vue&type=template&id=0708af86&"
import script from "./BookHourlyDepartmentCard.vue?vue&type=script&lang=ts&"
export * from "./BookHourlyDepartmentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports